import React, { useState, useEffect } from 'react';
import { Button, CircularProgress, IconButton, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import PDFSingleViewer from '../components/PDFSingleViewer';
import ImgSingleViewer from '../components/ImgSingleViewer';
import { makeS3BlobsRenderable } from '../../src/util/fileHandling';
import {
  fetchPatientInsurance,
  // deletePatientInsuranceFile,
} from '../../src/services/api';

function PatientsAttachments(props) {
  const {
    patientId,
    classes: { previewImg, btnSpacing, customFloatLeft, pageTurners },
  } = props;
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [openImgModal, setOpenImgModal] = useState(false);
  const [currentPDF, setCurrentPDF] = useState([]);
  const [currentImg, setCurrentImg] = useState('');
  const [fileDn, setFileDn] = useState([]);
  const [pageIndex, setPageIndex] = useState(0);
  const [token, setToken] = useState('');

  const pageLimit = 2;
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        await getPatientInsuranceFiles();
      } catch (err) {
        enqueueSnackbar("Unable to fetch patient's insurance");
      }
      setIsLoading(false);
    })();
  }, [pageIndex]);

  const getPatientInsuranceFiles = async () => {
    const fetchPatientFiles = await fetchPatientInsurance(patientId, token);
    setFileDn(fetchPatientFiles.data);
    setToken(fetchPatientFiles?.data[0]?.continuationToken);
    const imageObjects = makeS3BlobsRenderable(fetchPatientFiles.data);
    const sortedArray = sortedBydate(imageObjects);
    setImages(sortedArray);
    setIsLoading(false);
  };

  const sortedBydate = array => {
    return array.sort((a, b) =>
      moment(b.LastModified).diff(moment(a.LastModified))
    );
  };

  const onPageBack = async () => {
    if (pageIndex === 0) {
      enqueueSnackbar('You are on the first page');
    } else {
      setPageIndex(pageIndex - 1);
    }
  };

  const onPageForward = async () => {
    setPageIndex(pageIndex + 1);
  };

  const handleOpenPDF = link => {
    setOpenPDFModal(true);
    setCurrentPDF(link);
  };

  const downloadAll = async () => {
    images.forEach((element, index) => {
      var link = document.createElement('a');
      link.download = 'attachment';
      link.target = '_blank';
      // Construct the URI
      link.href = element.dataUrl;
      document.body.appendChild(link);
      setTimeout(function() {
        link.click();
        // Cleanup the DOM
        document.body.removeChild(link);
      }, 500 * index);
    });
  };

  // Delete Patient Insurance File
  // const handleDeleteInsurance = async id => {
  //   try {
  //     await deletePatientInsuranceFile(patientId, id);
  //   } catch (error) {
  //     enqueueSnackbar("Unable to delete patient's insurance");
  //   }
  // };

  const handleOpenImg = link => {
    setOpenImgModal(true);
    setCurrentImg(link);
  };

  return isLoading ? (
    <div className={props.classes.loading}>
      <CircularProgress />
    </div>
  ) : (
    <>
      <div className="attachmentView paddingZero">
        <Grid>
          {images && images.length == 0 ? (
            <div>No files added</div>
          ) : (
            images.map((image, index) =>
              image?.fileType === 'pdf' ? (
                <>
                  <div className={btnSpacing}>
                    {/* <span>{index + 1 + '.'}</span> &nbsp;&nbsp; */}
                    <span>
                      {moment(image.LastModified).format('MM/DD/YYYY') + '.'}
                    </span>{' '}
                    &nbsp;&nbsp;
                    {/* <Button
                      color="primary"
                      variant="contained"
                      onClick={() => handleDeleteInsurance(image.id)}
                    >
                      X
                    </Button> */}
                    <Button
                      color="primary"
                      disabled={
                        image?.fileType === 'htm' ||
                        image?.fileType === 'html;base6'
                      }
                      variant="contained"
                      onClick={() => handleOpenPDF(image.dataUrl)}
                    >
                      Click To Preview
                    </Button>
                  </div>

                  <PDFSingleViewer
                    openPDFModal={openPDFModal}
                    currentPDF={currentPDF}
                    onClose={() => setOpenPDFModal(false)}
                  />
                </>
              ) : (
                <Grid container className={customFloatLeft} item xs={6}>
                  <Grid className={btnSpacing} item xs={12}>
                    {/* <span>{index + 1 + '.'}</span> &nbsp;&nbsp; */}
                    <span>
                      {moment(image.LastModified).format('MM/DD/YYYY') + '.'}
                    </span>{' '}
                    &nbsp;&nbsp;
                    {/* <Button
                      color="primary"
                      variant="contained"
                      onClick={() => handleDeleteInsurance(image.id)}
                    >
                      X
                    </Button> */}
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={
                        image?.fileType === 'htm' ||
                        image?.fileType === 'html' ||
                        image?.fileType === 'html;base6'
                          ? null
                          : () => handleOpenImg(image.dataUrl)
                      }
                    >
                      {image?.fileType === 'htm' ||
                      image?.fileType === 'html' ||
                      image?.fileType === 'html;base6'
                        ? 'Html File'
                        : '   Click to enlarge'}
                    </Button>
                    {image?.fileType === 'htm' ||
                    image?.fileType === 'html' ||
                    image?.fileType === 'html;base6' ? (
                      <div>
                        To see full report, please click download all button
                      </div>
                    ) : (
                      <div className="imgCenter">
                        <img
                          src={image && image.dataUrl}
                          key={`picture-${index}`}
                          className={previewImg}
                        />
                      </div>
                    )}
                    <ImgSingleViewer
                      openImgModal={openImgModal}
                      currentImg={currentImg}
                      onClose={() => setOpenImgModal(false)}
                    />
                  </Grid>
                </Grid>
              )
            )
          )}
          {images && images.length > 0 && (
            <Grid container item xs={12}>
              <button
                className="custom-download-all-btn custom-attachment-btn popup-download-btn"
                onClick={() => downloadAll()}
              >
                Download All
              </button>
            </Grid>
          )}
        </Grid>
      </div>
      <div className={pageTurners}>
        <IconButton disabled={pageIndex === 0}>
          <ArrowBackIosIcon
            style={{ opacity: pageIndex === 0 ? '0.5' : '1.0' }}
            color="primary"
            variant="contained"
            onClick={onPageBack}
          />
        </IconButton>
        <IconButton>
          <ArrowForwardIosIcon
            style={{ opacity: images.length < pageLimit ? '0.5' : '1.0' }}
            color="primary"
            variant="contained"
            onClick={onPageForward}
          />
        </IconButton>
      </div>
    </>
  );
}

const styles = () => ({
  btnSpacing: {
    marginBottom: '15px',
  },
  textCenter: {
    textAlign: 'center',
  },
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    overflow: 'visible',
  },
  actions: {
    marginTop: '1em',
  },
  input: {
    margin: '0.5em 0',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
  previewImg: {
    maxWidth: 300,
    maxHeight: 300,
    marginBottom: '1em',
    marginTop: '1em',
    width: 300,
    height: 300,
  },
  customFloatLeft: {
    width: '50%',
    display: 'inline-block',
  },
  attachmentResponsive: {
    width: 'auto',
  },
  pageTurners: {
    width: '100%',
    marginTop: '5px',
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export default withStyles(styles)(PatientsAttachments);
